export const DRAW_STYLES: any[] = [
  {
    id: 'gl-draw-polygon-fill-inactive',
    type: 'fill',
    filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'active', 'true']] as any,
    paint: { 'fill-color': '#00C853', 'fill-opacity': 0.25 },
  },
  {
    id: 'gl-draw-polygon-fill-active',
    type: 'fill',
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'true']] as any,
    paint: { 'fill-color': '#00E676', 'fill-opacity': 0.3 },
  },
  {
    id: 'gl-draw-polygon-stroke-inactive',
    type: 'line',
    filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'active', 'true']] as any,
    paint: { 'line-color': '#00E676', 'line-width': 3 },
  },
  {
    id: 'gl-draw-polygon-stroke-active',
    type: 'line',
    filter: ['all', ['==', '$type', 'Polygon'], ['==', 'active', 'true']] as any,
    paint: { 'line-color': '#00FF95', 'line-width': 4 },
  },

  {
    id: 'gl-draw-polygon-and-line-vertex-halo-active',
    type: 'circle',
    filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']] as any,
    paint: { 'circle-radius': 7, 'circle-color': '#ffffff' },
  },
  {
    id: 'gl-draw-polygon-and-line-vertex-active',
    type: 'circle',
    filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']] as any,
    paint: { 'circle-radius': 4, 'circle-color': '#00C853' },
  },
  {
    id: 'gl-draw-polygon-midpoint-halo',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']] as any,
    paint: { 'circle-radius': 6, 'circle-color': '#ffffff' },
  },
  {
    id: 'gl-draw-polygon-midpoint',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']] as any,
    paint: { 'circle-radius': 4, 'circle-color': '#d4d4d4' },
  },
  {
    id: 'gl-draw-polygon-and-line-vertex-active-selected',
    type: 'circle',
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['==', 'active', 'true']] as any,
    paint: { 'circle-radius': 5, 'circle-color': '#2196F3', 'circle-stroke-width': 2, 'circle-stroke-color': '#fff' },
  },
];
